<template>
  <div class="content">
    <Form :model="formData" :label-width="150">
      <!-- <FormItem label="模板编号">
        <Input v-model="formData.template_id" style="width: 420px" :disabled="!isEdit"></Input>
      </FormItem> -->
      <FormItem label="短信通道">
        <Select
          v-model="formData.channel_id"
          style="width: 420px"
          :disabled="!isEdit"
          filterable
          clearable
          placeholder="请选择短信通道"
          @on-change="handleChannelChange"
        >
          <Option v-for="item of channelList" :key="item.channel_id" :value="item.channel_id">
            {{ item.channel_name }}
          </Option>
        </Select>
        <div v-if="hasInvalidChannel" class="invalid-channel-row">
          <span class="invalid-channel-name">短信通道：{{ invalidChannelName }}</span>
          <Tooltip placement="right" max-width="420" content="该短信通道已失效或被删除，请编辑后重新选择">
            <span class="invalid-channel-status">
              <Icon type="ios-alert-outline" />
              已失效
            </span>
          </Tooltip>
        </div>
      </FormItem>
      <FormItem label="参数内容">
        <Input type="textarea" :rows="3" v-model="formData.parameters" style="width: 620px" :disabled="!isEdit"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
        <Button type="primary" v-show="isEdit" @click="save">保存</Button>
        <Button style="margin-left: 8px" v-show="isEdit" @click="cancel">取消</Button>
      </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getSmsConfigCompanyChannelListA } from '@/server/api'

const SMS_CHANNEL_NAME_CACHE_KEY = 'sms_channel_name_cache';

export default {
  data() {
    return {
      isEdit: false,
      channelList: [],
      lastSelectedChannelName: '',
      formData: {
        template_id: '',                 //短信模板编号
        channel_id: '',                  //短信通道id
        channel_name: '',                //短信通道名称
        parameters: '',              //短信模板参数内容  可使用变量 ${xxx} 形式 此处变量取自用户导入的额外字段信息
      },
    }
  },
	computed: {
    ...mapState('setting', ['sms']),
    hasInvalidChannel() {
      if (!this.formData.channel_id) return false;
      const currentChannelId = String(this.formData.channel_id);
      return !this.channelList.some(item => String(item.channel_id) === currentChannelId);
    },
    invalidChannelName() {
      const channelId = this.formData.channel_id;
      return (
        this.formData.channel_name ||
        this.lastSelectedChannelName ||
        this.getCachedChannelName(channelId) ||
        '历史通道'
      );
    },
	},
  watch: {
    sms: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    }
  },
  created() {
    this.getChannelList();
  },
  methods: {
    ...mapActions('setting', ['updateSms']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    resetForm() {
      const sms = Array.isArray(this.sms) ? (this.sms[0] || {}) : this.sms;
      this.formData = { ...this.formData, ...sms }
      this.lastSelectedChannelName = sms?.channel_name || '';
    },
    save() {
      this.updateSms({
        template_id: this.formData.template_id,
        channel_id: ~~this.formData.channel_id,
        channel_name: this.formData.channel_name,
        parameters: this.formData.parameters,
      });
      this.isEdit = false;
    },
    handleChannelChange(channelId) {
      const currentChannel = this.channelList.find(item => String(item.channel_id) === String(channelId));
      this.formData.channel_name = currentChannel?.channel_name || '';
      this.lastSelectedChannelName = this.formData.channel_name;
    },
    getCachedChannelName(channelId) {
      if (!channelId) return '';
      try {
        const cache = JSON.parse(window.localStorage.getItem(SMS_CHANNEL_NAME_CACHE_KEY) || '{}');
        return cache[String(channelId)] || '';
      } catch (e) {
        return '';
      }
    },
    updateChannelNameCache(channelList = []) {
      try {
        const oldCache = JSON.parse(window.localStorage.getItem(SMS_CHANNEL_NAME_CACHE_KEY) || '{}');
        const newCache = { ...oldCache };
        channelList.forEach((item) => {
          if (!item?.channel_id || !item?.channel_name) return;
          newCache[String(item.channel_id)] = item.channel_name;
        });
        window.localStorage.setItem(SMS_CHANNEL_NAME_CACHE_KEY, JSON.stringify(newCache));
      } catch (e) {
        // ignore cache errors
      }
    },
    getChannelList() {
      getSmsConfigCompanyChannelListA().then((res) => {
        if (res.code !== 200) return;
        this.channelList = Array.isArray(res.data) ? res.data : [];
        this.updateChannelNameCache(this.channelList);
        const currentChannel = this.channelList.find(
          item => String(item.channel_id) === String(this.formData.channel_id)
        );
        if (currentChannel) {
          this.formData.channel_name = currentChannel.channel_name;
          this.lastSelectedChannelName = currentChannel.channel_name;
        } else if (!this.lastSelectedChannelName) {
          this.lastSelectedChannelName = this.getCachedChannelName(this.formData.channel_id);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}

.invalid-channel-row {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  max-width: 540px;
}

.invalid-channel-name {
  max-width: 440px;
  color: #666;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.invalid-channel-status {
  display: inline-flex;
  align-items: center;
  color: #ed4014;
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
}

.invalid-channel-status .ivu-icon {
  margin-right: 4px;
}

.invalid-channel-status:hover {
  color: #f16643;
}
</style>
